/**
 * Color intention that you want to used in your theme
 * @param {JsonObject} theme Theme customization object
 */
export function themePalette(theme) {
    return {
        // mode: theme.customization.navType,
        mode: theme.customization.mode || 'light',
        common: {
            black: '#000000'
        },
        // primary: {
        //     light: theme.colors.primaryLight,
        //     main: theme.colors.primaryMain,
        //     dark: theme.colors.primaryDark,
        //     200: theme.colors.primary200,
        //     800: theme.colors.primary800
        // },
        // secondary: {
        //     light: theme.colors.secondaryLight,
        //     main: theme.colors.secondaryMain,
        //     dark: theme.colors.secondaryDark,
        //     200: theme.colors.secondary200,
        //     800: theme.colors.secondary800
        // },
        primary: {
            light: theme.customization.primaryColor + '33', // leve transparência
            main: theme.customization.primaryColor,
            dark: theme.customization.primaryColor,
            contrastText: '#fff'
        },
        secondary: {
            light: theme.customization.secondaryColor + '33',
            main: theme.customization.secondaryColor,
            dark: theme.customization.secondaryColor,
            contrastText: '#fff'
        },
        error: {
            light: theme.colors.errorLight,
            main: theme.colors.errorMain,
            dark: theme.colors.errorDark
        },
        orange: {
            light: theme.colors.orangeLight,
            main: theme.colors.orangeMain,
            dark: theme.colors.orangeDark
        },
        warning: {
            light: theme.colors.warningLight,
            main: theme.colors.warningMain,
            dark: theme.colors.warningDark
        },
        success: {
            light: theme.colors.successLight,
            200: theme.colors.success200,
            main: theme.colors.successMain,
            dark: theme.colors.successDark
        },
        grey: {
            50: '#fafafa',
            100: '#f5f5f5',
            200: '#eeeeee',
            300: '#e0e0e0',
            400: '#bdbdbd',
            500: '#9e9e9e',
            600: '#757575',
            700: '#616161',
            800: '#424242',
            900: '#212121'
        },
        text: {
            primary: theme.darkTextPrimary,
            secondary: theme.darkTextSecondary,
            dark: theme.textDark,
            hint: theme.colors.grey100
        },
        background: {
            paper: theme.paper,
            default: theme.backgroundDefault
        }
    };
}
